import { OperationTypeEnum, QaQcTestResultEnum, RejectionReasonsEnum, ShiftsEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
@Entity('rejections')
export class Rejections {

  @PrimaryGeneratedColumn("increment", { name: 'rejection_id' })
  rejectionId: number;

  @Column('int', {
    nullable: false,
    name: "plant_id"
  })
  plantId: number;

  @Column({
      type: 'enum',
      enum: ShiftsEnum,
      nullable: false,
      name: 'shift'
  })
  shift: ShiftsEnum;

  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "lot_number"
  })
  lotNumber: string;
  
  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "sub_lot_number"
  })
  subLotNumber: string;

  @Column("int",{
    nullable:false,
    name:"sale_order_id"
  })
  saleOrderId:number;

  @Column("int",{
    nullable:false,
    name:"sale_order_item_id"
  })
  saleOrderItemId:number;

  @Column("int",{
    nullable:false,
    name:"count"
  })
  count:number;

  @Column({
      type: 'enum',
      enum: OperationTypeEnum,
      nullable: true,
      name: 'operation'
  })
  operation: OperationTypeEnum;

  @Column('int', {
    nullable: false,
    name: "workstation"
  })
  workstation: number;

  @Column("int", {
    nullable: false,
    name: "test_id"
  })
  testId: number;

  @Column("int", {
    nullable: false,
    name: "samples"
  })
  samples: number;

  @Column("int", {
    nullable: false,
    name: "quantity"
  })
  quantity: number;

  @Column("int", {
    nullable: false,
    name: "rejection_quantity"
  })
  rejectionQuantity: number;

  @Column({
    type: 'enum',
    enum: RejectionReasonsEnum,
    nullable: true,
    name: "rejection_reason"
  })
  rejectionReason: RejectionReasonsEnum;

  @Column("varchar",{
    nullable: true,
    name: "test_result"
  })
  testResult: string;

  @Column("varchar", {
    nullable: true,
    name: "remarks"
  })
  remarks: string;
 
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
 
}